import * as React from "react";
import { RouterProvider } from "react-router-dom";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { routes } from "./route";
import { useAppDispatch } from "./store/hooks";
import { authAction } from "./store/authentication";
import { dashboardAction } from "./store/dashboard";
import "@fontsource/roboto/400.css"; // Weight 400
import "@fontsource/roboto/500.css"; // Weight 500
import "@fontsource/roboto/700.css"; // Weight 700
import { Helmet } from 'react-helmet';

const App = (): React.ReactElement => {
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    const handleResize = () => {
      dispatch(dashboardAction.setIsMobile(window.innerWidth <= 500));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    const getFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      dispatch(authAction.setDeviceDetails(result.visitorId));
    };
    getFingerprint();
  }, []);
  const environment = process.env.REACT_APP_ENV;

  return (
    <div>
     <Helmet>
        {environment !== 'production' && (
          <meta name="robots" content="noindex, nofollow" />
        )}
        <title>SelectDr - Choose Better. Get Better.</title>
      </Helmet>
      {/* <EventLogger> */}
        <div>
        <RouterProvider router={routes} />
        </div>
      {/* </EventLogger> */}
    </div>
  );
};

export default App;
